import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { SweepstakesWrapper, SweepstakesEntryCard, SweepstakesDrawerContainer, } from '@thd-olt-component-react/loyalty-benefits';
import { windowExists } from '../../components/Utils';
var SWEEPSTAKES_MOCK_DATA = {
    notOptedIn: {
        id: 'fifa-2024',
        title: 'WIN FIFA WORLD CUP TICKETS!',
        description: 'Complete challenges to earn entries for a chance to win World Cup tickets.',
        theme: 'FIFA',
        logo: 'https://placehold.co/44x98/000000/FFFFFF?text=FIFA',
        heroImage: 'https://placeholder.pics/svg/957x262/7a3de7-f07153/ffffff-Placeholder',
        expirationDate: '4/09/2026',
        termsAndConditions: '**Important Details About the Sweepstakes:**\n\n' +
            '* This sweepstakes will run for a duration of three weeks (03/19/2026 - 04/09/2026)\n\n' +
            '* If selected as a winner, you will be contacted over email or phone to confirm your personal details and ' +
            'match selections\n\n' +
            '* The prizes included in this sweepstakes cannot be redeemed for cash or credit',
        status: 'New',
        isOptedIn: false,
        completedSteps: 0,
        totalSteps: 4,
        steps: [
            {
                id: 'survey',
                title: 'Take a Survey',
                subtitle: 'To edit your personal details or match selections, please call (770) 433-8211',
                iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
                completed: false,
            },
            {
                id: 'push-notifications',
                title: 'Turn on Notifications',
                subtitle: null,
                iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
                completed: false,
                ctaTitle: 'Turn on Push Notifications',
            },
            {
                id: 'store-mode',
                title: 'Experience Store Mode',
                subtitle: null,
                iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
                completed: false,
                ctaTitle: 'Open Store Mode',
            },
            {
                id: 'qualifying-purchase',
                title: 'Purchase via the App',
                subtitle: null,
                iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
                completed: false,
            },
        ],
        ctaTitle: 'Take Survey',
        ctaHref: null,
        ctaOnclick: null,
    },
    partiallyCompleted: {
        id: 'fifa-2024',
        title: 'WIN FIFA WORLD CUP TICKETS!',
        description: 'Complete challenges to earn entries for a chance to win World Cup tickets.',
        theme: 'FIFA',
        logo: 'https://placehold.co/44x98/000000/FFFFFF?text=FIFA',
        heroImage: 'https://placeholder.pics/svg/957x262/7a3de7-f07153/ffffff-Placeholder',
        expirationDate: '4/09/2026',
        termsAndConditions: '**Important Details About the Sweepstakes:**\n\n' +
            '* This sweepstakes will run for a duration of three weeks (03/19/2026 - 04/09/2026)\n\n' +
            '* If selected as a winner, you will be contacted over email or phone to confirm your personal details and ' +
            'match selections\n\n' +
            '* The prizes included in this sweepstakes cannot be redeemed for cash or credit',
        status: '2 of 4 Completed',
        isOptedIn: true,
        completedSteps: 2,
        totalSteps: 4,
        steps: [
            {
                id: 'survey',
                title: 'Take a Survey',
                subtitle: 'To edit your personal details or match selections, please call (770) 433-8211',
                description: 'No entries earned for more chances to win.',
                iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
                completed: true,
                instructions: 'Complete the survey to activate your sweepstakes entry.',
            },
            {
                id: 'push-notifications',
                title: 'Turn on Notifications',
                subtitle: null,
                description: 'To turn on push notifications for The Home Depot app, you will need to go into your ' +
                    "device's Settings. If you haven't done so already, make sure to install the Home Depot app.",
                iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
                completed: true,
                instructions: '**To Turn On Notifications:**\n\n' +
                    '1. Open the Settings app\n' +
                    '2. Tap on Notifications\n' +
                    '   -If you have an Android device, tap App Notifications to see your installed apps\n' +
                    '3. Select The Home Depot app under Notification Style\n' +
                    '4. Tap the Allow Notifications toggle to turn it on\n' +
                    '   -The toggle will turn green\n\n' +
                    '**Important Details on Managing Alerts:**\n\n' +
                    'From the Lock Screen:\n' +
                    '* Tap a single notification to open the corresponding app\n' +
                    '* Touch and hold the notification for quick access without opening the app\n' +
                    '* If you missed an alert, swipe up from the middle of your Lock Screen\n\n' +
                    '**From the Home Screen:**\n' +
                    '* Tap the banner as it appears to open the corresponding app',
                ctaTitle: 'Turn on Push Notifications',
                eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_notifications',
            },
            {
                id: 'store-mode',
                title: 'Experience Store Mode',
                subtitle: null,
                description: 'To use Store Mode, you must be in a physical Home Depot store. After opening the app ' +
                    'while in the store, navigate to "Store Mode" on the bottom of your screen.\n\n' +
                    'It will automatically activate when you enter the store to help you find items faster and ' +
                    'navigate the store more efficiently.',
                iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
                completed: false,
                instructions: '**To Experience Store Mode:**\n\n' +
                    '1. Open The Home Depot app\n' +
                    '   -You must be in store to use Store Mode\n' +
                    '2. Select your store\n' +
                    '   -The app may automatically detect it\n' +
                    '3. Search for a product\n' +
                    '4. Tap on the map icon to see its location within the store\n\n' +
                    '**Important Details About Store Mode:**\n\n' +
                    'Store Mode can be used while shopping at any Home Depot store location. Store Mode helps ' +
                    'you plan your trip efficiently and unlocks the following benefits:\n\n' +
                    '* Pre-select desired items online\n' +
                    '* Get personalized product recommendations\n' +
                    '* Optimize your in-store route for faster shopping',
                ctaTitle: 'Open Store Mode',
                eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_store-mode',
            },
            {
                id: 'qualifying-purchase',
                title: 'Purchase via the App',
                subtitle: null,
                description: null,
                iconUrl: 'https://placehold.co/32x32/000000/FFFFFF?text=%23',
                completed: false,
                instructions: 'Make a qualifying purchase through The Home Depot app to complete this step.',
                ctaTitle: 'Shop Now',
                eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_shop',
            },
        ],
        ctaTitle: null,
        ctaHref: null,
        ctaOnclick: null,
    },
};
export var SweepstakesDemoContainer = function (_a) {
    var isLoading = _a.isLoading, children = _a.children;
    var dataNotOpted = SWEEPSTAKES_MOCK_DATA.notOptedIn;
    var dataOptedIn = SWEEPSTAKES_MOCK_DATA.partiallyCompleted;
    var FS_SWEEPSTAKES_DEMO = 'ENABLE_SWEEPSTAKES_DEMO';
    var FS_TOGGLE = 'ENABLE_SWEEPSTAKES_DEMO_NON_OPTED';
    var fsSweepstakesValue = useConfigService(FS_SWEEPSTAKES_DEMO);
    var fsToggleValue = useConfigService(FS_TOGGLE);
    // Check URL query params for overrides
    var urlParams = new URLSearchParams(windowExists() ? window.location.search : '');
    var urlSweepstakesDemo = urlParams.get(FS_SWEEPSTAKES_DEMO);
    var urlToggleValue = urlParams.get(FS_TOGGLE);
    // Use URL params if present, otherwise fall back to feature service values
    var sweepstakesValue = urlSweepstakesDemo !== null && urlSweepstakesDemo !== void 0 ? urlSweepstakesDemo : fsSweepstakesValue;
    var toggleValue = urlToggleValue !== null && urlToggleValue !== void 0 ? urlToggleValue : fsToggleValue;
    var isSweepstakesEnabled = ['1', 1].includes(sweepstakesValue);
    var isNonOptedEnabled = ['1', 1].includes(toggleValue);
    // Show NotOpted if FS is available & toggled off.
    // Show OptedIn if FS is available & toggled on.
    // If FS is unavailable, show OptedIn (default).
    var data = isNonOptedEnabled ? dataNotOpted : dataOptedIn;
    // const faqOnClick = () =>
    //   window.open('http://www.homedepot.com/c/fifa-world-cup-2026', '_blank');
    var headerProps = {
        showOutsideHeaderOn: 'MW',
        showInsideHeaderOn: ['TW', 'DT'],
        // onClick: faqOnClick,
        href: 'http://www.homedepot.com/c/fifa-world-cup-2026',
        openNewWindow: true,
    };
    return isSweepstakesEnabled ? (React.createElement(SweepstakesWrapper, { sweepstakesData: data, cacheKey: "sweepstakes-demo" },
        React.createElement(SweepstakesEntryCard, { SweepstakesEntryCardHeaderProps: headerProps }),
        React.createElement(SweepstakesDrawerContainer, null))) : (React.createElement(React.Fragment, null, children));
};
